import axios from "./axiosInstance";
import {
  FeeTypeApiResponse,
  FeeTypesApiResponse,
  FeeTypeCreatePayload,
  FeeTypeUpdatePayload,
  FeeTypeSearchParams
} from "../types/feeTypeTypes";
  
/**
 * Create a new fee type
 */
export const createFeeType = async (payload: FeeTypeCreatePayload): Promise<FeeTypeApiResponse> => {
  const response = await axios.post<FeeTypeApiResponse>("/fee-types", payload);
  return response.data;
};

/**
 * Search fee types with optional parameters
 */
export const getAllFeeTypes = async (params: FeeTypeSearchParams): Promise<FeeTypesApiResponse> => {
  const response = await axios.get<FeeTypesApiResponse>("/fee-types", { params: { ...params, page: 1, limit: 10000 } });
  return response.data;
};

/**
 * Fetch a specific fee type by ID
 */
export const getFeeTypeById = async (feeTypeId: string): Promise<FeeTypeApiResponse> => {
  const response = await axios.get<FeeTypeApiResponse>(`/fee-types/${feeTypeId}`);
  return response.data;
};

/**
 * Update an existing fee type
 */
export const updateFeeType = async (feeTypeId: string, payload: FeeTypeUpdatePayload): Promise<FeeTypeApiResponse> => {
  const response = await axios.put<FeeTypeApiResponse>(`/fee-types/${feeTypeId}`, payload);
  return response.data;
};

/**
 * Delete a fee type
 */
export const deleteFeeType = async (feeTypeId: string): Promise<FeeTypeApiResponse> => {
  const response = await axios.delete<FeeTypeApiResponse>(`/fee-types/${feeTypeId}`);
  return response.data;
};

export const getClassLevels = async () => {
  const response = await axios.get("/reference/class-levels");
  return response.data;
};


